import React from "react";

const AboutMe = () => {
	return <div>About-me</div>;
};

export default AboutMe;
